import { isObject } from "./is-object";

type Obj = Record<string, unknown>;

export const merge = <T extends Obj>(defaultObj: Obj, newObj: Obj): T => {
  const result = structuredClone(defaultObj);

  for (const key in newObj) {
    if (isObject(newObj[key])) {
      const defaultValue = isObject(result[key]) ? (result[key] as Obj) : {};

      const newValue = newObj[key] as Obj;

      result[key] = merge(defaultValue, newValue) as T[typeof key];
    } else {
      result[key] = newObj[key];
    }
  }

  return result as T;
};
